import { IIconProps } from '~/types';
const SettingsIcon = ({ fill = '#7B7986', ...props }: IIconProps) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 12c0-.865.11-1.704.316-2.504A3 3 0 0 0 5.49 4.867a10 10 0 0 1 4.335-2.506 3 3 0 0 0 5.348 0 10 10 0 0 1 4.335 2.506 3 3 0 0 0 2.675 4.63c.206.8.316 1.638.316 2.503 0 .864-.11 1.703-.316 2.503a3 3 0 0 0-2.675 4.63 10 10 0 0 1-4.335 2.505 3 3 0 0 0-5.348 0 10 10 0 0 1-4.335-2.505 3 3 0 0 0-2.675-4.63C2.61 13.703 2.5 12.864 2.5 12m4.804 3c.63 1.091.81 2.346.564 3.524q.613.436 1.297.75A5 5 0 0 1 12.5 18c1.26 0 2.438.471 3.335 1.274q.684-.314 1.297-.75A5 5 0 0 1 17.696 15a5 5 0 0 1 2.77-2.25 8 8 0 0 0 0-1.5A5 5 0 0 1 17.696 9a5 5 0 0 1-.564-3.524 8 8 0 0 0-1.297-.75A5 5 0 0 1 12.5 6a5 5 0 0 1-3.335-1.274 8 8 0 0 0-1.297.75A5 5 0 0 1 7.304 9a5 5 0 0 1-2.77 2.25 8 8 0 0 0 0 1.5A5 5 0 0 1 7.305 15m5.196 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      fill={fill}
    />
  </svg>
);
export default SettingsIcon;
